type AnalyticsPayload = Record<string, string | number | boolean | null | undefined>;

declare global {
  interface Window {
    dataLayer?: AnalyticsPayload[];
  }
}

export function trackEvent(eventName: string, payload: AnalyticsPayload = {}): void {
  window.dataLayer = window.dataLayer ?? [];
  const eventPayload = {
    event: eventName,
    project: "solar-leads",
    ...payload,
    timestamp: new Date().toISOString()
  };
  window.dataLayer.push(eventPayload);

  window.dispatchEvent(
    new CustomEvent("solar-leads:analytics", {
      detail: eventPayload
    })
  );
}
